import { Component, Input, Output, EventEmitter, ElementRef, ViewChild, ViewChildren, QueryList, OnChanges, SimpleChanges, AfterViewInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-scroll-picker',
    templateUrl: './scroll-picker.component.html',
    styleUrls: ['./scroll-picker.component.scss'],
    standalone: false
})
export class ScrollPickerComponent implements OnChanges, AfterViewInit, OnDestroy {
  private scrollTimeout: any;
  @Input() items: string[] = [];
  @Input() selected: string = '';
  @Input() label: string = '';
  @Input() height: number = 0;
  
  @Output() selectionChange = new EventEmitter<string>();

  @ViewChild('container') containerRef!: ElementRef;
  @ViewChildren('itemBtn') itemRefs!: QueryList<ElementRef>;
  constructor(
    private translateService: TranslateService,
  ) {
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selected'] || changes['items']) {
      this.scrollToSelected();
    }
  }

  ngAfterViewInit(): void {
    this.scrollToSelected();
  }

  onItemClick(item: string): void {
    this.selectionChange.emit(item);
  }

  private scrollToSelected(): void {
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }
    this.scrollTimeout = setTimeout(() => {
      const idx = this.items.indexOf(this.selected);
      if (idx >= 0) {
        const itemArr = this.itemRefs.toArray();
        const container: HTMLElement | undefined = this.containerRef?.nativeElement;
        if (itemArr[idx] && container) {
          // Card #403: scroll THIS list only. scrollIntoView also scrolled every scrollable
          // ancestor, so where the picker stacks the time under the calendar (phones, narrow
          // dialogs) it opened scrolled past the calendar. Layout offsets, not on-screen
          // rects: the dialog is still in its scale-in animation when this runs. The list is
          // position: relative, so it is the button's offsetParent.
          const item: HTMLElement = itemArr[idx].nativeElement;
          const top = Math.max(0, item.offsetTop - (container.clientHeight - item.offsetHeight) / 2);
          if (typeof container.scrollTo === 'function') {
            container.scrollTo({ top, behavior: 'smooth' });
          } else {
            container.scrollTop = top;
          }
        }
      }
    }, 50);
  }

  ngOnDestroy(): void {
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }
  }
  getTranslatedText(key: string): string {
    const translation = this.translateService.instant(key);
    return translation !== key ? translation : '';
  }
}
